var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-file',{ref:"uploader",attrs:{"disabled":_vm.disabled,"multiple":_vm.multiple,"state":_vm.error ? false : null,"value":_vm.fromValue(_vm.value)},on:{"input":function($event){_vm.filesChanged(_vm.fromValue(arguments[0]))}}})}
var staticRenderFns = []

export { render, staticRenderFns }